import { School } from "../types/school";

export const getTitle = (schools: School[], id: string) => {
  return schools.find((s) => s.school_id === id)?.title;
};
